module.exports = __webpack_public_path__ + "img/interests2.cabac15f.svg";